export default {
  order: "Заказ",
  similar: "Похожие",
  queue: "Очередь",
  dateOfCreation: "Дата создания",
  orderNumber: "Номер заказа",
  foreignNumber: "Номер у партнера",
  status: "Статус",
  fullname: "Полное имя",
  price: "Цена",
  phone: "Телефон",
  type: "Тип",
  tracker: "Трекер",
  created: "Создано",
  updated: "Изменено",
  noSimilarOrders: "Похожиx заказов не найдено",
  products: "Продукты",
  tickets: "Тикеты",
  noTickets: "Тикетов не найдено",
  id: "#",
  theme: "Тема",
  category: "Категория",
  yes: "Да",
  no: "Нет",
  activity: "Активность",
  messagesQuantity: "Кол-во сообщений",
  dateOfLastMessage: "Дата последнего сообщения",
  createTicket: "Создать тикет",
  ticket: "Тикет",
  saveTicket: "Сохранить тикет",
  saveTicketSuccess: "Тикет успешно сохранен",
  saveTicketMessageSuccess: "Сообщение успешно сохранено",
  noTicketMessages: "Сообщений нет",
  author: "Автор",
  message: "Сообщение",
  add: "Добавить",
  problemResolved: "Проблема решена",
  problemLeft: "Проблема осталась",
  requestToCourier: "Запрос в курьерскую службу",
  requestToCourierShort: "Запрос в курьерку",
  transfer: "Передать",
  hire: "Принять в работу",
  noData: "Данные отсутствуют",
  totalOrders: "Всего заказов",
  approved: "Одобрено",
  approvedPercent: "% одобрено",
  rejected: "Отклоны",
  rejectedPercent: "% отклоны",
  totalApprovesCost: "Сумма за одобренные",
  buyout: "Выкуп",
  refusal: "Отказ",
  inDelivery: "В доставке",
  runLevelApproves: "УВ по Апруву",
  runLevelBuyouts: "УВ по Выкупу",
  runLevelMiddleCheck: "УВ по СЧ",
  runLevelCheckList: "УВ по ЧЛ",
  runLevel: "Общий УВ",
  runLevelK: "Коэффициент УВ",
  orderRate: "Стоимость апрува",
  buybackPlan: "План по выкупу",
  approvePlan: "План по апруву",
  midcheckPlan: "План по среднему чеку",
  midcheckPackages: "Cредний чек (в упаковках)",
  wage: "Оклад",
  premium: "Премия",
  premium_ps: "Премия ПП",
  premium_lc: "Премия ПШ",
  repeatPremium: "Постпродажи",
  invoicePremium: "По счету",
  workingHours: "Время работы",
  ppLimitExceeded: "Превышение ПО",
  voicemailExceeded: "Превышение AО",
  payedHours: "Оплаченные часы",
  salaryIndications: "Показатели зарплаты",
  premiumIndications: "Показатели для премии",
  premiumIndicationsPS: "Показатели для премии ПП",
  statisticCurrentMonth: "Статистика за текущий месяц",
  statIndications: "Статистика заказов",
  currentIndications: "Показатели за текущий месяц",
  statIndicationsPS: "Статистика заказов ПП",
  currentIndicationsPS: "Показатели за текущий месяц ПП",
  fines: "Штрафы",
  fine: "Штраф",
  audits: "Аудит",
  surcharges: "Доплаты",
  date: "Дата",
  name: "Название",
  amount: "Сумма",
  description: "Описание",
  userFineAssigned: "Тот кто назначил доплату/штраф",
  operator: "Оператор",
  surchargeOrFine: "Доплата или штраф",
  trainings: "Тренинги",
  trainingName: "Название тренинга",
  trainer: "Тренер",
  durationsAndHours: "Длительность, часы",
  dateOfTraining: "Дата тренинга",
  surcharge: "Доплата",
  totalSalary: "Итого к выплате",
  country: "Страна",
  mine: "Мой",
  midPackagesCheck: "Средний чек (упаковок)",
  approves: "Апрувы",
  time: "Время",
  approvesForCurrentMonth: "Апрувы за текущий месяц",
  productStatistics: "Статистика по товарам",
  mobile: "Мобильный",
  create: "Создать",
  cancel: "Отменить",
  requestType: "Тип запроса",
  topOperators: "Топ операторов",
  comment: "Комментарий",
  request: "Запрос",
  productsForManagement: "Товары для доотправки",
  recallOrders: "Заказы для перезвона",
  notifications: "Уведомления",
  myRecalls: "Мои перезвоны",
  rating: "Показатели",
  calculator: "Калькулятор",
  timePassed: "Время прошло",
  created_at: "Время создания",
  delete: "Удалить",
  deleteAll: "Удалить все",
  notificationsSuccessfullyDelete: "Уведомления успешно удалены",
  recallDate: "Дата перезвона",
  partner: "Партнер",
  clientName: "Имя клиента",
  stationary: "Стационарный",
  history: "История",
  common: "Общее",
  statuses: "Статусы",
  dateTime: "Дата и время",
  ignoreFinStatus: "Игнорировать фин статус",
  rejectReason: "Причина отказа",
  treatment: "Обработка",
  dateChange: "Дата изменения",
  script: "Скрипт",
  cost: "Цена",
  quantity: "Количество",
  action: "Действие",
  newStatus: "Новый статус",
  orderSaveSuccess: "Заказ успешно сохранен",
  statistic: "Статистика",
  training: "Обучение",
  trainingDesc:
    "Изучите продукты, пройдите промежуточные тесты на усвоение материала и сдайте итоговый экзамен, чтобы открыть доступ к скриптам и CRM",
  start: "Начало",
  newCategoryDesc:
    "Изучение материала по новой категории.",
  beginEducation: "Начать обучение",
  check: "Проверить",
  checkingLearned: "Проверка выученного",
  assimilateMaterialText:
    "Похоже вы усвоили материал, переходите к следующему продукту.",
  perfect: "Отлично!",
  notAssimilateMaterialText:
    "Похоже вы не очень хорошо усвоили материал, повторите ещё раз и пересдайте тест",
  testFailedText:
    "Похоже вы не справились с тестированием. Свяжитесь с вашим куратором для дальнейших инструкций",
  ooops: "Ой!",
  exam: "Экзамен",
  examDesc:
    "Насколько хорошо вы знаете продукцию, с которой предстоит работать",
  preparation: "Подготовка",
  retraining: "Переподготовка",
  prepareExamText:
    "Перед началом экзамена рекомендуем как следует выучить продукты и сдать промежуточные тесты. На экзамен отводится 30 минут и две попытки.",
  retrainingExamText:
    "Не волнуйтесь! Поработайте над ошибками, повторите пройденный материал и попробуйте сдать экзамен ещё раз. На экзамен отводится 30 минут.",
  startExam: "Начать экзамен",
  timerStartAfterButton: "Таймер запустится сразу после нажатия кнопки",
  alas: "Увы!",
  youMade: "Вы сделали",
  errorsInExam: "ошибки в тесте и не прошли экзамен",
  prepareExamAgainText:
    "У вас есть ещё один день, чтобы подготовиться и попытка, чтобы пересдать",
  reExam: "Пересдать экзамен",
  noAttemptsExamText:
    "У вас не осталось попыток, свяжитесь с куратором для дальнейших инструкций",
  writeCurator: "Написать куратору",
  congratulations: "Поздравляем!",
  andPassExam: "и прошли экзамен",
  youAnswered: "Вы ответили на",
  notAllAnswered: "Внимательно! Ты не ответил на вопрос",
  questionsFrom: "вопросов из",
  familiarizeWithScriptsText:
    "Ознакомьтесь со скриптами и приступайте к работе",
  noAttemptsExamDesc:
    "Вы сделали {count} ошибки в тесте и не прошли экзамен. У вас не осталось попыток, свяжитесь с куратором для далбнейших инструкций",
  checkLearned: "Проверить выученное",
  testCompleteTitle: "Спасибо за участие!",
  testCompleteText: "Система начала обработку твоих результатов.",
  drag: "Перетащите",
  or: "или",
  selectFile: "Выберите файл",
  changeLang: "Изменить язык",
  resetLang: "Сменить язык",
  validationError: "Ошибка валидации",
  invalidField: "Невалидное поле",
  validationOnlyNumbers: "Поле должно иметь только числа",
  maxLength: "Максимальная длина",
  minLength: "Минимальная длина",
  validationRequire: "Поле обязательное к заполнению",
  noItemsInOrder: "В заказе нет товаров",
  notOnlyOneFreeProduct: "В заказе может быть только один бесплатный товар",
  noAllFreeProductsInOrder: "В заказе все товары не могут быть бесплатными",
  basket: "Корзина",
  save: "Сохранить",
  vat: "НДС",
  vatWithout: "Без НДС",
  total: "Итого",
  delievery: "Доставка",
  permalink: "Отправить ссылку для оплаты",
  discount: "Скидка",
  chooseStatus: "Выберите статус",
  settings: "Настройки",
  logout: "Выход",
  finishWork: "Закончить работу",
  finishWorkAfterOrder: "Закончить работу после обработки заказа",
  education: "Образование",
  candidate: "Соискатель",
  orderProcessingTime: "Время обработки заказа",
  all: "Все",
  notLearned: "Не выучено",
  learned: "Выучено",
  learnedAll: "Все выучено",
  testText:
    "Тест, насколько хорошо вы знаете продукцию, с которой предстоит работать",
  untilExam: "До экзамена",
  learn: "Учить",
  continueLearn: "Продолжить обучение",
  passTest: "Сдать тест",
  passFailed: "Тест провален",
  nextQuestion: "Следующий вопрос",
  nextButton: "Следующий",
  prevButton: "Предыдущий",
  passExam: "Сдать экзамен",
  question: "Вопрос",
  from: "из",
  back: "Назад",
  nextStep: "Следующий шаг",
  signUp: "Записаться",
  submitInspection: "Отправить на проверку",
  letsMeet: "Давайте познакомимся",
  tellAboutYourself: "Расскажите немного о себе",
  surname: "Фамилия",
  dateOfBirth: "Дата рождения",
  countryResidence: "Страна проживания",
  city: "Город",
  lookingJob: "Ищу работу",
  employment: "Занятость",
  fully: "Полная",
  part: "Частичная",
  iHave: "У меня есть",
  computerOrLaptop: "Компьютер или ноутбук",
  headset: "Гарнитура с шумоподавлением",
  quietWorkPlace: "Тихое рабочее место",
  yourExperience: "Какой у вас опыт работы?",
  doInLastJob: "Чем вы занимались на последнем месте работы?",
  doInLastJob2: "Было ли это связано с торговлей или общением с людьми?",
  doInLastJob3: "Что вы продавали и как успешно?",
  workExperience: "Опыт работы",
  cvDesc: "Можете пропустить этот пункт, но наличие резюме будет плюсом",
  foreignLangs: "Инностранные языки",
  nativeLangs: "Родные языки",
  whitchFreely: "Которыми владеете свободно",
  cv: "Резюме",
  dateInterviewText: "Выберите дату и время для собеседования",
  skypeDesc:
    "Скайп нужен для созвона с эйчаром, а контактный телефон — на случай, если не сможем вас найти в Скайпе",
  skypeNick: "Ник в скайпе",
  forInterview: "Для собеседования",
  concludeContract: "Заключить контракт",
  concludeContractDesc:
    "Скачайте, распечатайте и подпишите контракт. Загрузите скан или фотографию подписанной страницы.",
  addressResidense: "Адрес проживания",
  actual: "Фактический",
  pasportAndSeries: "Серия и номер паспорта",
  passportScan: "Скан паспорта",
  contractScan: "Скан контракта",
  contractScanDesc: "Скачайте, распечатайте и подпишите контракт",
  ddmmyyyy: "ДД ММ ГГГГ",
  appliance: "Применение",
  contra: "Противопоказание",
  volume: "Объем",
  countryDescription: "Описание страны",
  additional_information: "Дополнительная информация",
  format: "Формат",
  consistance: "Состав",
  atAllTimes: "На постоянно",
  forSecondJob: "Для подработки",
  docOrPdf: "doc или pdf",
  orderGeneral: "Информация о клиенте",
  orderAddress: "Адрес доставки",
  possibleValue: "Возможные корректные значения для",
  productsAndSets: "Товары и сеты",
  addressInOrder: "Адрес в заказе",
  shipping: "Служба доставки",
  location: "Локация",
  unlockAndEnterManually: "Разблокировать и ввести вручную",
  sumWithoutVAT: "Сумма без НДС",
  interviewInSkype: "Собеседование в Скайпе",
  waitingApprove: "Ожидание одобрения",
  begin: "Начать",
  waitApproveToEducation: "Ожидайте потверждения для начала обучения",
  meInformation: "Информация О Себе",
  workExpAndLang: "Опыт работы и языки",
  interviewRec: "Запись на собеседование",
  contractAndStart: "Контракт и начало работы",
  meAndInterview: "Рассказ о себе и собеседовение",
  successOneStep: "Успех! Остался всего один шаг",
  fillAboutPersonal: "Заполните поля о ваших личных данных",
  aboutLangExp: "Расскажите о вашем опыте работы и владении языками",
  aboutContacts: "Укажите ваши контакты и дату проведения собеседования",
  signContract: "Подпишите контракт и приступайте к работе",
  unicallWelcome:
    "Приглашаем вас приединиться к команде Юниколл. Подпишите контракт и приступайте к работе.",
  requestChecking:
    "Ваша заявка принята и обрабатывается. Ждём вас. По итогам собеседования вам будет доступен контракт.",
  formContract: "Оформите контракт и приступайте к работе",
  passed: "Сдано",
  deleteMobPhone: "Удалить мобильный номер",
  toShutdown: "Осталось до отключения",
  continueWork: "Продолжить работу",
  confirmStartWork: "Подтверждение начала работы",
  confirmStartWorkDesc: "Вы готовы начать работать над данным проектом?",
  addProductOrSet: "добавить товар или сет",
  free: "Бесплатно",
  sets: "Сеты",
  close: "Закрыть",
  startScript: "Запустить скрипт",
  commonScripts: "Общие скрипты",
  productScripts: "Скрипт продукта",
  gettingStarted: "Начало работы",
  scriptsByCountry: "Язык скрипта",
  startWork: "Начать работу",
  gettingStartedDesc:
    "Нажмите кнопку «Начать работу», чтобы начать работать над заказами",
  secondAttempt: "Вторая попытка",
  nextAttempt: "Следующая попытка",
  youEarned: "Вы заработали",
  finish: "Завершить",
  continue: "Продолжить",
  hour: "час",
  inOnline: "Время онлайн",
  substatus: "Субстатус",
  numAndType: "Номер и тип",
  countryCode: "Код страны",
  nameShort: "Имя",
  accessDenied: "Доступ запрещен",
  wrongProductsQuantity: "Неверное количество товара",
  sendInfoOrder: "Отправить информацию про заказ",
  orderInfo: "Информация про заказ",
  approvedWithoutLink: "Одобрить без ссылки",
  autoApproveByLink: "Автоматический аппрув по ссылке",
  audioAccessDenied: "Доступ к микрофону запрещен.",
  audioAccessDeniedInfo:
    "{intro} Разрешите доступ в настройках браузера для совершения звонков",
  phoneRegisteredError: 'Ошибка подключения к телефонии',
  selectCorrection: "Выберите корректировку",
  selectCombo: "Выберите комбо",
  invalidPrice: "Невалидная цена",
  requiredField: "Это поле обязательно",
  waitingComingCall: "Ожидайте входящий звонок",
  available: "Доступно",
  costPerItem: "Стоимость за 1 шт",
  costPerItemWithoutVAT: "Стоимость за 1 шт без НДС",
  mainItemBaseCostWithoutVAT: "Базовая стоимость за 1 шт без НДС",
  finalCost: "Конечная стоимость",
  discountType: "Тип скидки",
  finesAmount: "Размер штрафа",
  checklistTotal: "Баллы",
  presenceOfErrors: "Наличие ошибок",
  auditErrorCategory: "Категория ошибок",
  auditError: "Ошибка аудита",
  chooseOperator: "Выберите оператора",
  productStatisticCurrentMonthTitle: "Статистика по товарам за текущий месяц",
  fact: "Факт",
  forecast: "Прогноз",
  grade: "Ранг",
  calculate: "Посчитать",
  hourRate: "Ставка / час",
  workingHoursQty: "Кол-во отработанных часов",
  approvalPercent: "Фактический УВП по апруву, %",
  averageCheck: "Фактический средний чек",
  averageCheckPercent: "Фактический УВП по среднему чеку, %",
  averageCheckPercent2: "Прогнозный УВП по среднему чеку, %",
  percentageOfBuyout: "Фактический УВП по выкупу, %",
  approvalPercent2: "Прогнозный УВП по апруву, %",
  averageCheck2: "Прогнозный средний чек",
  percentageOfBuyout2: "Прогнозный УВП по выкупу, %",
  valOfChecklistPoints: "Кол-во баллов чек-листа",
  amountOfapprovedOrders: "Количество подтвержденных заказов",
  order_rate: "Стоимость 1 подтвержденного лида",
  run_level: "Общий увп",
  noFulfillment: "Нет доступных fulfillment",
  recordsList: "Список записей",
  orderLogId: "ID лога заказа",
  confirmOrderApproveData: "Подтверждение данных заказа",
  checkList: "Чек-лист",
  points: "Баллы",
  checkListBlock: "Блок чек-листа",
  checkListStage: "Этап чек-листа",
  checkListTotalPoints: "Всего баллов",
  auditInfo: "Информация по аудиту",
  auditErrors: "Ошибки аудита",
  auditPointsSummary: "Подытог",
  selectTrainingTopic: "Выберите тему тренировки",
  switchToTrainingCheckbox: "Перейти в режим тренировки после обработки заказа",
  startTraining: "Начать тренировку",
  finishTraining: "Закончить тренировку",
  thingsShort: "шт.",
  salesTax: "Sales tax: ",
  confirmSendInfoToClient: "Подтвердите отправку информации клиенту",
  localTime: "Местное время сейчас",
  orderLocalTime: "Местное время заказа",
  elaboration: "Проработка",
  approvesInDeliveryTitle: "Заказы в доставке",
  productStatForPayPeriod: "Статистика по товарам за период оплаты",
  postSales: "Постпродажи",
  lastChance: "Последний шанс",
  notCorrectField: "В поле {field} указано неверное значение",
  deliveryStatus: "Статус доставки",
  orderCountry: "Страна заказа",
  cantSaveStatusDuringCall: "Нельзя сохранить статус во время звонка",
  audioCourse: "Аудио курс",
  attestation: "Аттестация",
  beginAttestation: "Начать аттестацию",
  continueAttestation: "Продолжить аттестацию",
  attemptsQty: "Попытки",
  failed: "Провалено",
  finishTest: "Завершить тест",
  confirmFailStatus: "Вы уверены что хотите присвоить недозвон?",
  lastCallDuration: "Продолжительность разговоров",
  attestationsResults: "Результаты аттестации",
  blockPoints: "Баллы по блокам",
  finished_at: "Время прохождения",
  totalPoints: "Всего баллов",
  productPlans: "Планы по товару",
  offerPlans: "Планы по офферу",
  myClients: "Мои клиенты",
  ordersInDelivery: "Заказы в доставке",
  ordersRejected: "Отказы",
  ordersNotBuyout: "Невыкупы",
  salesCoefficient: "Коэффициент продаж",
  buyoutCoefficient: "Коэффициент выкупа",
  averageApprovedPerHour: "Среднее количество апрувов в час",
  buyouts: "Выкупы",
  riskZone: "Зона риска",
  riskZoneMark: "Метка зоны риска",
  lastCall: "Дата последнего звонка",
  note: "Заметка",
  offers: "Офферы",
  offerStatForPayPeriod: "Статистика по офферам за период оплаты",
  offerStatisticCurrentMonthTitle: "Статистика по офферам за текущий месяц",
  goodCalls: "Библиотека хороших звонков",
  recordDate: "Дата записи",
  auditDate: "Дата аудита",
  logStatus: "Статус звонка",
  record: "Запись",
  emptyProductField: "Выберите товар",
  callingListGeneral: "Номера для прозвона",
  enterPhoneNumbers: "Введите номера телефонов",
  enterOrderId: "Заказ по номеру телефона не найден, введите номера заказа",
  callingListTitle: "Список номеров телефонов для прозвона",
  linkActiveTime: "активность ссылки",
  orderProducts: "Товары",
  send: "Отправить",
  offer: "Оффер"
};
